import { render, staticRenderFns } from "./ListarSituacionRevista.vue?vue&type=template&id=bddb1bdc&"
import script from "./ListarSituacionRevista.vue?vue&type=script&lang=js&"
export * from "./ListarSituacionRevista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports